<template>
    <page>
        <module title="半成品详情">
            <div v-if="baseInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="产品分类">{{baseInfo.product_type_name}}</c-detail-item>
                    <c-detail-item label="产品图">
                        <template v-slot="{data}">
                            <c-image :src="baseInfo.product_image" size="60"></c-image>
                        </template>
                    </c-detail-item>
                    <c-detail-item label="中文名称">{{baseInfo.product_name}}</c-detail-item>
                    <c-detail-item label="英文名称">{{baseInfo.product_name_en}}</c-detail-item>
                    <c-detail-item label="产品号">{{baseInfo.product_number}}</c-detail-item>
                    <c-detail-item label="产品CAS号">{{baseInfo.product_cas_number}}</c-detail-item>
                </c-detail>
                <c-detail title="其他信息">
                    <c-detail-item label="分子式">{{baseInfo.formula}}</c-detail-item>
                    <c-detail-item label="分子量">{{baseInfo.formula_weight}}</c-detail-item>
                    <c-detail-item label="形态">{{baseInfo.form}}</c-detail-item>
                    <c-detail-item label="颜色">{{baseInfo.color}}</c-detail-item>
                    <c-detail-item label="沸点">{{baseInfo.boiling_point}}</c-detail-item>
                    <c-detail-item label="闪点">{{baseInfo.flash_point}}</c-detail-item>
                    <c-detail-item label="符号">{{baseInfo.symbol}}</c-detail-item>
                    <c-detail-item label="熔点">{{baseInfo.melting_point}}</c-detail-item>
                    <c-detail-item label="密度/比重">{{baseInfo.density}}</c-detail-item>
                    <c-detail-item label="MDL">{{baseInfo.mdl}}</c-detail-item>
                    <c-detail-item label="中文同义名" full>{{baseInfo.synonyms_zh}}</c-detail-item>
                    <c-detail-item label="英文同义名" full>{{baseInfo.synonyms_en  }}</c-detail-item>
                    <c-detail-item label="【中】产品介绍" full>{{baseInfo.introduce_zh}}</c-detail-item>
                    <c-detail-item label="【英】产品介绍" full>{{baseInfo.introduce_en}}</c-detail-item>
                </c-detail>
                <c-detail title="关联成品产品">
                    <c-table v-model="productList" :paging="false" height="auto" border>
                        <c-table-column
                                label="产品号"
                                name="product_number"
                        >
                        </c-table-column>
                        <c-table-column
                                label="产品中文名"
                                name="product_name"
                        >
                        </c-table-column>
                        <c-table-column
                                label="产品英文名"
                                name="product_name_en"
                        >
                        </c-table-column>
                        <c-table-column
                                label="产品CAS号"
                                name="product_cas_number"
                        >
                        </c-table-column>
                        <c-table-column
                                label="规格"
                                name="spec"
                        >
                        </c-table-column>
                        <c-table-column
                                type="button"
                                fixed="right"
                                label="操作"
                                width="60"
                        >
                            <template v-slot="row">
                                <c-table-button @click="navigateTo(`https://store.altascientific.com/#/mall/goods/detail?spuId=${row.data.product_id}`,true)">查看</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'material_detail',

        props: {
            id: String
        },

        components: {
        },

        data() {
            return {
                baseInfo: '',
                productList: []
            }
        },

        computed: {
        },

        watch: {
            id() {
                this.getDataDetail();
            }
        },

        mounted() {
            this.getDataDetail();
        },

        methods: {
            getDataDetail() {
                this.request({
                    url: '/material/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.baseInfo = data;
                        this.productList = data.product_list;
                    }
                });
          }
        }
    }
</script>